import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../../lib/content";

export default function Navigation() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 transition-all duration-300 backdrop-blur-xl ${
        scrolled
          ? "bg-cream/85 border-b border-paperline"
          : "bg-cream/60 border-b border-transparent"
      }`}
    >
      <div className="container-vk flex items-center justify-between h-20">
        <Link
          to="/"
          data-testid="brand-logo"
          className="group flex items-baseline gap-2"
        >
          <span className="heading-display text-2xl md:text-[26px] font-semibold tracking-tight text-ink">
            Victor Kwawukume
          </span>
          <span className="hidden md:inline-block w-1.5 h-1.5 rounded-full bg-burgundy translate-y-[-3px]" />
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `link-underline text-sm tracking-wide uppercase font-medium transition-colors ${
                  isActive ? "text-burgundy" : "text-ink hover:text-burgundy"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden inline-flex items-center justify-center w-11 h-11 border border-paperline text-ink hover:bg-ink hover:text-cream transition-colors"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu-panel"
          className="lg:hidden border-t border-paperline bg-cream"
        >
          <nav className="container-vk py-6 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-3 px-2 border-b border-paperline/70 text-sm uppercase tracking-wider font-medium ${
                    isActive ? "text-burgundy" : "text-ink"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
